// import * as jspdf from 'jspdf';
// anshorcpb

function getQuery(q) {
  return (window.location.search.match(new RegExp('[?&]' + q + '=([^&]+)')) || [, null])[1];
}

var rgb2cmyk = function (r, g, b, normalized) {
  var c = 1 - r / 255;
  var m = 1 - g / 255;
  var y = 1 - b / 255;
  var k = Math.min(c, Math.min(m, y));

  c = (c - k) / (1 - k);
  m = (m - k) / (1 - k);
  y = (y - k) / (1 - k);

  if (!normalized) {
    c = Math.round(c * 10000) / 100;
    m = Math.round(m * 10000) / 100;
    y = Math.round(y * 10000) / 100;
    k = Math.round(k * 10000) / 100;
  }

  if (normalized) {
    c = c == 0 ? 0 : c.toFixed(2);
    m = m == 0 ? 0 : m.toFixed(2);
    y = y == 0 ? 0 : y.toFixed(2);
    k = k == 0 ? 0 : k.toFixed(2);
  }

  c = isNaN(c) ? 0 : c;
  m = isNaN(m) ? 0 : m;
  y = isNaN(y) ? 0 : y;
  k = isNaN(k) ? 0 : k;

  return {
    c: `${c}`,
    m: `${m}`,
    y: `${y}`,
    k: `${k}`,
  };
};

const rgbaFromString = (rgbaString = '') => {
  const [r, g, b, a] = rgbaString.match(/\d+/g).map(Number);

  return { r, g, b, a };
};

const rgb2Hex = (s) =>
  s.match(/[0-9]+/g).reduce((a, b) => a + (b | 256).toString(16).slice(1), '#');

function makeRequest(method, url) {
  return new Promise(function (resolve, reject) {
    let xhr = new XMLHttpRequest();
    xhr.open(method, url);
    xhr.responseType = 'blob';
    xhr.onload = function () {
      if (this.status >= 200 && this.status < 300) {
        var reader = new FileReader();

        reader.onloadend = function () {
          const image = new Image();
          image.onload = function () {
            const ratio = image.width / image.height;
            console.log(`Aspect ratio: ${ratio}`);
            resolve({
              result: reader.result,
              width: image.width,
              height: image.height,
            });
          };
          image.src = reader.result;
        };
        reader.readAsDataURL(xhr.response);
      } else {
        reject({
          status: this.status,
          statusText: xhr.statusText,
        });
      }
    };
    xhr.onerror = function () {
      reject({
        status: this.status,
        statusText: xhr.statusText,
      });
    };
    xhr.send();
  });
}

function waitForElm(selector) {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver((mutations) => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}

var getImageData = async function (data = [], callback) {
  const newCtx = await cpbImageStorage.views.front.getPrintSnapshot();
  return newCtx;
};

var getImageDataBack = async function (data = [], callback) {
  if (!cpbImageStorage.views.back) {
    return '';
  }
  const newCtx = await cpbImageStorage.views.back.getPrintSnapshot();
  return newCtx;
};
const getStoreCPB = () => {
  return CPB.getStore().getState();
};
const getProductData = () => {
  const CPBStore = getStoreCPB();
  return CPBStore.Product;
};

const getProductLayer = () => {
  const CPBStore = getStoreCPB();
  return CPBStore.Product.layers;
};
const getFormData = () => {
  const currentData = getStoreCPB();

  const panels = currentData.Product.panels;
  const layers = currentData.Product.layers;

  let idToLayers = {};

  layers.forEach((item) => {
    idToLayers = {
      ...idToLayers,
      [item.option]: item.value,
    };
  });
  console.log('z', idToLayers);

  let currFormData = {};
  let currOrder = [];

  let index = 0;
  let colorInsideBody = {};
  let colorInsideSock = {};
  let colorInsideName = {};
  let colorOthers = {};
  panels.forEach((item) => {
    item.categories.forEach((category) => {
      category.options.forEach((option) => {
        if (option.id in idToLayers) {
          let keyOrder = category.id;
          let titleOrder = category.title;
          let value = idToLayers[option.id];
          if (category.title === 'Team Contact' && 'label' in option.option.data) {
            keyOrder = category.id + ' ' + option.option.data.label;
            titleOrder = category.title + ' ' + option.option.data.label;
          }

          if (category.title === 'Name' && 'label' in option.option.data) {
            keyOrder = category.id + ' ' + option.option.data.label;
            titleOrder =
              category.title +
              `${option.option.data.label !== 'Name' ? ` ${option.option.data.label}` : ''}`;
          }
          // if (category.title === 'Size' && 'label' in option.option.data) {
          //   keyOrder = category.id + ' ' + option.option.data.label;
          //   titleOrder = category.title + ' ' + option.option.data.label;
          // }

          currOrder.push(keyOrder);
          currFormData = {
            ...currFormData,
            [keyOrder]: {
              option: option,
              category: category,
              item: item,
              section: item.title,
              title: titleOrder,
              value: value,
              label:
                option.option.data && 'label' in option.option.data ? option.option.data.label : '',
            },
          };

          if (
            idToLayers[option.id] &&
            typeof idToLayers[option.id] === 'string' &&
            idToLayers[option.id].includes('rgba')
          ) {
            const colorLabel = idToLayers[option.id];

            if (item.title.includes('Jersey')) {
              colorInsideBody = {
                ...colorInsideBody,
                [colorLabel]: {
                  title: category.title,
                  color:
                    option.option.data && 'label' in option.option.data
                      ? option.option.data.label
                      : '',
                },
              };
              return;
            }
            if (item.title.includes('SOCKS')) {
              colorInsideSock = {
                ...colorInsideSock,
                [colorLabel]: {
                  title: category.title,
                  color:
                    option.option.data && 'label' in option.option.data
                      ? option.option.data.label
                      : '',
                },
              };
              return;
            }
            if (item.title.includes('Font')) {
              colorInsideName = {
                ...colorInsideName,
                [colorLabel]: {
                  title: category.title,
                  color:
                    option.option.data && 'label' in option.option.data
                      ? option.option.data.label
                      : '',
                },
              };
              return;
            }

            colorOthers = {
              ...colorOthers,
              [colorLabel]: {
                title: category.title,
                color:
                  option.option.data && 'label' in option.option.data
                    ? option.option.data.label
                    : '',
              },
            };
          }
        }
      });
    });
  });

  return {
    currFormData,
    currOrder,
    colorInsideBody,
    colorInsideSock,
    colorInsideName,
    colorOthers,
  };
};

const CellExcel = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
];

const parseNum = (str) => +str.replace(/[^.\d]/g, '');

const getExcelData = (url, callback = _.noop) => {
  var oReq = new XMLHttpRequest();

  oReq.open('GET', url, true);
  oReq.responseType = 'arraybuffer';
  let workbook;
  console.log('oReq', oReq);
  oReq.onload = function (e) {
    var arraybuffer = oReq.response;
    /* convert data to binary string */
    var data = new Uint8Array(arraybuffer);
    var arr = new Array();
    for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
    var bstr = arr.join('');
    /* Call XLSX */
    workbook = XLSX.read(bstr, {
      type: 'binary',
      cellStyles: true,
    });
    var first_sheet_name = workbook.SheetNames[0];
    var worksheet = workbook.Sheets[first_sheet_name];
    console.log(worksheet);

    const refSheet = worksheet['!ref'];

    let totalRows = 0;
    if (!_.isEmpty(refSheet)) {
      const test = refSheet.split(':');
      totalRows = parseNum(test[1]);
    }

    let headers = {};
    _.forEach(CellExcel, (head) => {
      const headRow = worksheet[`${head}1`];
      if (headRow && !_.isEmpty(headRow.v)) {
        headers = { ...headers, [headRow.v]: head };
      }
    });

    const nameList = ['NAME ON BACK'];
    const numberList = ['NUMBER'];
    const sizeList = ['JERSEY SIZE'];
    const sizeSocksList = ['SOCK SIZE'];
    const captainList = ['CAPTAIN?'];

    const nameHead = _.find(headers, (item, label) => nameList.includes(label));
    const numberHead = _.find(headers, (item, label) => numberList.includes(label));
    const sizeHead = _.find(headers, (item, label) => sizeList.includes(label));
    const captainHead = _.find(headers, (item, label) => captainList.includes(label));
    const sizeSocksHead = _.find(headers, (item, label) => sizeSocksList.includes(label));

    let importData = [];
    _.times(totalRows, (rowRawIndex) => {
      if (rowRawIndex === 0) {
        return;
      }
      const rowIndex = rowRawIndex + 1;
      const existNameValue = _.get(worksheet, `${nameHead}${rowIndex}.v`);
      const existNumberValue = _.get(worksheet, `${numberHead}${rowIndex}.v`);
      const existSizeValue = _.get(worksheet, `${sizeHead}${rowIndex}.v`);
      const existCaptainValue = _.get(worksheet, `${captainHead}${rowIndex}.v`);
      const existSockValue = _.get(worksheet, `${sizeSocksHead}${rowIndex}.v`);

      if (existNameValue) {
        importData = [
          ...importData,
          {
            name: existNameValue,
            number: existNumberValue,
            size: existSizeValue,
            captain: existCaptainValue,
            sockSize: existSockValue,
          },
        ];
      }
    });

    callback(importData);
    console.log('importData', importData);
  };
  oReq.send();
};
const logoJHQ =
  window.cpbLogo ||
  'https://cdn.shopify.com/s/files/1/0316/8390/3624/files/JHQ-logo_final_2d7701d8-5654-480d-a45e-060154741164_140x@2x.png?v=1580407344';

const addColorToPdf = ({ item, key, indexColor, yColor, marginPerColor, doc }) => {
  const { r, g, b } = rgbaFromString(key);
  const { c, m, y, k } = rgb2cmyk(r, g, b, true);
  const { color, title } = item;
  doc.text(color, 2.5 + marginPerColor * indexColor, yColor);
  doc.setFillColor(c, m, y, k);
  doc.rect(1 + marginPerColor * indexColor, yColor - 0.5, 1, 1, 'F');
  doc.text(title, 1 + marginPerColor * indexColor, yColor + 1);
};
const exportPdf = async () => {
  try {
    const getExportPdfButton = document.getElementById('export_pdf');
    if (getExportPdfButton) {
      document.getElementById('export_pdf').classList.add('disabled');
    }
    console.log(CPB.getStore().getState().Product.userChanges);
    const dataFront = await getImageData();
    const dataBack = await getImageDataBack();
    const dataForm = getFormData();
    // console.log('d', dataForm);
    const { currFormData, currOrder } = dataForm;

    console.log('currFormData test', currFormData, currOrder);

    let xlsRoster = '';
    let imageList = [];
    const dataTab = currOrder.map((item) => {
      if (
        typeof currFormData[item].title === 'string' &&
        currFormData[item].title.includes('Roster Upload')
      ) {
        xlsRoster = currFormData[item].value;
      }

      if (
        currFormData[item].value &&
        typeof currFormData[item].value === 'string' &&
        (currFormData[item].value.includes('.png') || currFormData[item].value.includes('.jpg'))
      ) {
        imageList = [...imageList, currFormData[item].value];
      }

      if (
        currFormData[item].title.includes('COLOR') ||
        currFormData[item].title.includes('Font Style') ||
        currFormData[item].title.includes('TEMPLATE') ||
        currFormData[item].title.includes('Templates') ||
        currFormData[item].title.includes('Fabric')
      ) {
        return {
          ...currFormData[item],
          value: currFormData[item].value ? currFormData[item].value : '',
          label: currFormData[item].label,
        };
      }

      if (currFormData[item].title.includes('Name')) {
        return {
          ...currFormData[item],
          value: currFormData[item].value ? currFormData[item].value : '',
          label: currFormData[item].value ? currFormData[item].value : currFormData[item].label,
        };
      }

      if (currFormData[item].label.includes('Name')) {
        console.log('currFormData[item].label', currFormData[item].label);
        return {
          ...currFormData[item],
          value: currFormData[item].value ? currFormData[item].value : '',
          label: currFormData[item].value ? currFormData[item].value : currFormData[item].label,
        };
      }

      return {
        ...currFormData[item],
        value: currFormData[item].value ? currFormData[item].value : '',
        label: currFormData[item].value ? currFormData[item].value : currFormData[item].label,
      };
    });

    const doc = new jspdf.jsPDF('p', 'in', [60, 60]);

    if (dataBack) {
      doc.addImage(dataFront, 'JPEG', 0, 10, 30, 30);
      doc.addImage(dataBack, 'JPEG', 30, 10, 30, 30);
    } else {
      doc.addImage(dataFront, 'JPEG', 10, 10, 40, 40);
    }
    let { result, width: widthImage, height: heightImage } = await makeRequest('GET', logoJHQ);
    if (result) {
      const ratio = widthImage / heightImage;
      const heightNormal = 4;
      const widthNormal = heightNormal * ratio;
      console.log(`Aspect ratio: ${ratio}`, widthNormal, heightNormal);
      doc.addImage(result, 'JPEG', 1, 1, widthNormal, heightNormal);
    }

    doc.line(1, 5, 58, 5);
    doc.line(1, 50, 58, 50);
    let indexColor = 0;
    let indexColoY = 0;

    const marginPerColor = 6;
    doc.setFontSize(40);

    if (Object.keys(dataForm.colorInsideBody).length > 0) {
      const yColor = 51.5 + indexColoY * 2.5;
      doc.setFontSize(50);
      doc.text('Body', 1, yColor);
      doc.setFontSize(40);
      indexColor = indexColor + 1;
      Object.keys(dataForm.colorInsideBody).forEach((key) => {
        const item = dataForm.colorInsideBody[key];
        addColorToPdf({ item: item, indexColor, yColor, marginPerColor, doc, key });
        indexColor = indexColor + 1;
      });
    }
    indexColor = 0;

    if (Object.keys(dataForm.colorInsideSock).length > 0) {
      indexColoY = indexColoY + 1;
      const yColor = 51.5 + indexColoY * 2.5;
      doc.setFontSize(50);
      doc.text('Socks', 1 + marginPerColor * indexColor, yColor);
      doc.setFontSize(40);
      indexColor = indexColor + 1;
      Object.keys(dataForm.colorInsideSock).forEach((key) => {
        const item = dataForm.colorInsideSock[key];
        addColorToPdf({ item: item, indexColor, yColor, marginPerColor, doc, key });
        indexColor = indexColor + 1;
      });
    }

    indexColor = 0;
    if (Object.keys(dataForm.colorInsideName).length > 0) {
      indexColoY = indexColoY + 1;
      const yColor = 51.5 + indexColoY * 2.5;
      doc.setFontSize(50);
      doc.text('Number', 1 + marginPerColor * indexColor, yColor);
      doc.setFontSize(40);
      indexColor = indexColor + 1;
      Object.keys(dataForm.colorInsideName).forEach((key) => {
        const item = dataForm.colorInsideName[key];
        addColorToPdf({ item: item, indexColor, yColor, marginPerColor, doc, key });
        indexColor = indexColor + 1;
      });
    }
    indexColor = 0;
    if (Object.keys(dataForm.colorOthers).length > 0) {
      indexColoY = indexColoY + 1;
      const yColor = 51.5 + indexColoY * 2.5;
      doc.setFontSize(50);
      doc.text('Others', 1 + marginPerColor * indexColor, yColor);
      doc.setFontSize(40);
      indexColor = indexColor + 1;
      Object.keys(dataForm.colorOthers).forEach((key) => {
        const item = dataForm.colorOthers[key];
        addColorToPdf({ item: item, indexColor, yColor, marginPerColor, doc, key });
        indexColor = indexColor + 1;
      });
    }

    doc.addPage();
    console.log('dataTab', dataTab);
    doc.setFontSize(40);
    doc.line(1, 5, 58, 5);
    if (result) {
      const ratio = widthImage / heightImage;
      const heightNormal = 4;
      const widthNormal = heightNormal * ratio;
      console.log(`Aspect ratio: ${ratio}`, widthNormal, heightNormal);
      doc.addImage(result, 'JPEG', 1, 1, widthNormal, heightNormal);
    }
    var header = ['section', 'title', 'label'];
    var links = [];
    if (dataTab) {
      doc.autoTable({
        startY: 8,
        headStyles: {
          halign: 'center',
          fontSize: 100,
        },
        columnStyles: {
          section: { halign: 'center', fontSize: 90, minCellWidth: 18 },
          title: { halign: 'center', fontSize: 90, minCellWidth: 18 },
          label: { halign: 'center', fontSize: 90, minCellWidth: 18 },
        }, // European countries centered
        body: dataTab,
        columns: [
          { header: 'Section', dataKey: 'section' },
          { header: 'Title', dataKey: 'title' },
          { header: 'Label', dataKey: 'label' },
        ],
        didDrawCell: async (data) => {},
      });
    }

    const shopUrl = window.Shopify.shop;
    let currentShop = '';
    let shortCodeShop = '';

    const shopToValue = {
      jerseyhq: 'JHQ',
      hormesispaintball: 'HMS',
    };

    if (shopUrl) {
      currentShop = shopUrl.split('.')[0];
      shortCodeShop = shopToValue[currentShop] || 'JHQ';
    }

    if (xlsRoster) {
      getExcelData(xlsRoster, (dataExcel) => {
        if (dataExcel) {
          doc.addPage();
          doc.autoTable({
            startY: 8,
            headStyles: {
              halign: 'center',
              fontSize: 100,
            },
            columnStyles: {
              name: { halign: 'center', fontSize: 90, minCellWidth: 15 },
              number: { halign: 'center', fontSize: 90, minCellWidth: 10 },
              size: { halign: 'center', fontSize: 90, minCellWidth: 10 },
              captain: { halign: 'center', fontSize: 90, minCellWidth: 10 },
              sockSize: { halign: 'center', fontSize: 90, minCellWidth: 10 },
            },
            body: dataExcel,
            columns: [
              { header: 'Name', dataKey: 'name' },
              { header: 'Number', dataKey: 'number' },
              { header: 'Size', dataKey: 'size' },
              { header: 'Captain', dataKey: 'captain' },
              { header: 'SockSize', dataKey: 'sockSize' },
            ],
          });
        }

        const ProductData = getProductData();
        doc.save(ProductData.name);
        const dataPost = window.dataDansu;

        const pdf = new File([doc.output('blob')], 'myDoc.pdf', {
          type: 'application/pdf',
        });

        var client = new XMLHttpRequest();

        var formData = new FormData();

        if (dataPost && currentShop) {
          formData.append('dataDansu', JSON.stringify(dataPost));
          const configID = getQuery('configid');
          formData.append('files', pdf, `${shortCodeShop}_` + configID + '.pdf');
          client.open('post', `https://dansu.ubxinc.com:3003/upload/${currentShop}`, true);
          //         client.open('post', 'http://localhost:3001/upload/jerseyhq', true);
          client.send(formData);
        }
      });

      return;
    }

    const ProductData = getProductData();
    doc.save(ProductData.name);

    const pdf = new File([doc.output('blob')], 'myDoc.pdf', {
      type: 'application/pdf',
    });

    var client = new XMLHttpRequest();

    var formData = new FormData();
    const configID = getQuery('configid');

    if (currentShop) {
      formData.append('files', pdf, `${shortCodeShop}_` + configID + '.pdf');
      client.open('post', 'https://dansu.ubxinc.com:3003/upload/jerseyhq', true);
      client.send(formData);
    }

    // if (!_.isEmpty(imageList)) {
    //   doc.addPage();

    //   _.forEach(imageList, async (item) => {
    //     let result = await makeRequest('GET', item);
    //     doc.addImage(result, 'PNG', 1, 1, 3, 3);
    //   });
    // }
    if (getExportPdfButton) {
      document.getElementById('export_pdf').classList.remove('disabled');
    }
  } catch (e) {
    console.log('e', e);
    setTimeout(exportPdf, 1000);
  }
};

const autoDownloadTrigger = async (newButton) => {
  // CPB.appIsMounted
  let intervalId;
  function checkAppIsMounted(callback) {
    intervalId = setInterval(() => {
      if (CPB.appIsMounted) {
        clearInterval(intervalId);
        callback();
      }
    }, 1000); // Check every 1 second
  }

  // document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', function (event) {
  //   console.log('App is mounted');
  //   newButton.click();
  // });
  // checkAppIsMounted(() => {
  //   console.log('App is mounted');
  //   newButton.click();
  //   // Perform your callback logic here
  // });
};
const makeExportButton = (headContainer) => {
  const newButton = document.createElement('button');
  newButton.id = 'export_pdf';
  newButton.innerText = 'Export PDF';
  newButton.addEventListener('click', exportPdf);
  headContainer.appendChild(newButton);
  // ?configid=FdSAUp59JVyWCzBLfLjNLX_y to load saved Product
  // https://api.thecustomproductbuilder.com/configData/jerseyhq/6889636561087/FdSAUp59JVyWCzBLfLjNLX_y api
};

function updateQueryStringParameter(uri, key, value) {
  var re = new RegExp('([?&])' + key + '=.*?(&|#|$)', 'i');
  if (uri.match(re)) {
    return uri.replace(re, '$1' + key + '=' + value + '$2');
  } else {
    var hash = '';
    if (uri.indexOf('#') !== -1) {
      hash = uri.replace(/.*#/, '#');
      uri = uri.replace(/#.*/, '');
    }

    var separator = uri.indexOf('?') !== -1 ? '&' : '?';
    return uri + separator + key + '=' + value + hash;
  }
}

const saveProgress = () => {
  window._cpb.saveConfig(async function (res) {
    var configId = await window._cpb.saveConfig(null, false);
    var url = updateQueryStringParameter(window.location.href, 'configid', configId);
    await navigator.clipboard.writeText(url);
    alert('Copied to clipboard: ' + url);
    //YOUR CUSTOM CODE HERE (In case you want to pass it over to sharing etc.
  }, false);
};

const makeSaveButton = (headContainer) => {
  const newButton = document.createElement('button');
  newButton.id = 'save_progress';
  newButton.innerText = 'Save Progress';
  newButton.addEventListener('click', saveProgress);
  headContainer.appendChild(newButton);
};

var cpbLoaded = async function () {
  // const elm = await waitForElm('#react-tabs-2');
  const headContainer = await waitForElm('.cpb-product-actions-container');
  console.log('headContainer', headContainer);

  if (getQuery('design')) {
    makeExportButton(headContainer);
  }
  makeSaveButton(headContainer);
};
function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', async function (event) {
  console.log('App is mounted');
  const autoDownload = getQuery('autodownload');
  await cpbLoaded();
  if (autoDownload) {
    const headContainer = await waitForElm('.cpb-product-actions-container');
    console.log('autoDownload', autoDownload);
    await delay(3000);
    await getImageData();
    await delay(1000);
    exportPdf();
  }
});
